





































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import AsesmenKeperawatanIgdPage from "@/pages/PemeriksaanIgdPage/AsesmenKeperawatanIgdPage.vue";
import SurveyPrimerIgdPage from "@/pages/PemeriksaanIgdPage/SurveyPrimerIgdPage.vue";
import AsesmenMedisIgdPage from "@/pages/PemeriksaanIgdPage/AsesmenMedisIgdPage.vue";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import { isEmpty } from "lodash";

@Component({
  components: {
    AsesmenKeperawatanIgdPage,
    SurveyPrimerIgdPage,
    AsesmenMedisIgdPage
  }
})
export default class Index extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  // @Prop() showBtn!: boolean;
  // @Prop() showRiwayat!: boolean;
  defaultTab = "tab-perawat";
  // paramPerawat = {
  //   unit_id: this.stateuser.unit_id,
  //   reg: this.register,
  //   profesi: "perawat"
  // };
  paramDokter = {
    unit_id: this.stateuser.unit_id,
    reg: this.register,
    profesi: "Dokter"
  };

  param = {
    unit_id: this.stateuser.unit_id,
    reg: this.register
  };

  get stateuser() {
    return userModule.user;
  }

  get asesmenPerawatDone() {
    return !isEmpty(AsesmenKeperawatanGadarStore.asesmen) ? true : false;
  }

  get asesmenSurveyDone() {
    return !isEmpty(SurveyPrimerIgdStore.asesmen) ? true : false;
  }

  get asesmenMedisDone() {
    return !isEmpty(AsesmenMedisIgdStore.asesmen) ? true : false;
  }

  mounted() {
    AsesmenKeperawatanGadarStore.getByRegister(this.register);
    AsesmenMedisIgdStore.getByRegister(this.register);
    SurveyPrimerIgdStore.getByRegister(this.register);

    if (this.stateuser.profesi == "Dokter") {
      this.defaultTab = "tab-dokter";
    }
  }

  klikTabPerawat() {
    // const paramPerawat = {
    //   unit_id: this.stateuser.unit_id,
    //   reg: this.register,
    //   profesi: "Perawat",
    // };
    // storeDiagnosisPemeriksaan.actDiagnosis_perawat(paramPerawat);
    // storeRencanaPemeriksaan.actRencanaPemeriksaan_perawat(paramPerawat);
  }

  klikTabDokter() {
    // storeDiagnosisPemeriksaan.actDiagnosis_dokter(this.paramDokter);
    // storeRencanaPemeriksaan.actRencanaPemeriksaan_perawat(this.paramDokter);
  }

  soap() {
    this.$emit("isiSoap");
  }
}
